import getFileMimeType from '@quicktools/shared-components/utils/getFileMimeType';

export default async function isJpegFile(file: File) {
  const mimeType = await getFileMimeType(file);

  return 'image/jpeg' === mimeType;
}
